import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import CardStats from "components/Cards/Dashboard/CardStats.js";
// import UserDropdown from "components/Dropdowns/UserDropdown.js";
import componentStyles from "assets/theme/components/headers/stats-header.js";
import { Group, Star, Receipt, AttachMoney, Check, AccountBalanceWallet, FeaturedPlayListOutlined, HourglassEmptyRounded } from "@material-ui/icons";

import { useAsyncEffect } from "use-async-effect"
import { redirectToLogout } from "common/SharedFn";
import { getStats, getPendingActionOrdersCount } from "network/ApiAxios";

const useStyles = makeStyles(componentStyles);
const createHistory = require("history").createBrowserHistory;

const StatsHeader = ({
  section,
  subsection,
  showViewToggle = false,
  view = "app",
  onViewChange,
  posStats = null,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  // When the dashboard passes view="pos" (and POS data exists), render the
  // walk-in POS tiles instead of the app tiles. Other pages never pass these
  // props, so they keep the original app-only behaviour.
  const showPos = view === "pos" && posStats;

  const [numberOfOrders, setNumberOfOrders] = useState(0);
  const [numberOfUsers, setNumberOfUsers] = useState(0);
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);
  const [avgRating, setAvgRating] = useState(0.0);
  const [revenue, setRevenue] = useState(0.0);
  const [activeProSubscriptions, setActiveProSubscriptions] = useState(0.0);
  const [numberOfProSubscriptions, setNumberOfProSubscriptions] = useState(0.0);
  const [net, setNet] = useState(0.0);
  const [sales, setSales] = useState(0.0);
  const [totalSales, setTotalSales] = useState(0.0);
  const [walletTotal, setWalletTotal] = useState(0.0);
  const [cashTotal, setCashTotal] = useState(0.0);
  const [nonCashTotal, setNonCashTotal] = useState(0.0);
  const [sumForProActiveOrdersWithoutVat, setSumForProActiveOrdersWithoutVat] = useState(0.0);
  const [proSubscriptionSales, setProSubscriptionSales] = useState(0.0);
  const [activeSubscriptions, setActiveSubscriptions] = useState(0);
  const [frozenSubscriptions, setFrozenSubscriptions] = useState(0);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  let currency = localStorage.getItem("selectedCountry") == 2 ? "SAR" : "BHD";

  const callGetStats = async () => {
    setIsLoading(true);
    const response = await getStats();
    const { data } = response;
    if (data.result.isSuccess) {
      setNumberOfOrders(data.data.numberOfOrders);
      setNumberOfUsers(data.data.numberOfUsers);
      setAvgRating(data.data.avgRating);
      setRevenue(data.data.revenue);
      setSales(data.data.sales);
      // setSubscriptionSales(data.data.subscriptionSales);
      setSumForProActiveOrdersWithoutVat(data.data.sumForProActiveOrdersWithoutVat);
      setProSubscriptionSales(data.data.proSubscriptionSales);
      setTotalSales(data.data.totalSales);
      setNet(data.data.net);
      setActiveProSubscriptions(data.data.activeProSubscriptions);
      setNumberOfProSubscriptions(data.data.numberOfProSubscriptions);
      setWalletTotal(data.data.walletTotal);
      setCashTotal(data.data.cashTotal);
      setNonCashTotal(data.data.nonCashTotal);
      setActiveSubscriptions(data.data.activeSubscriptions);
      setFrozenSubscriptions(data.data.frozenSubscriptions);
    } else {
      showErrorNotification(data.result.description);
      if (data.result.code == -2) {
        redirectToLogout();
      }
    }
    setIsLoading(false);
  };

  const callGetPendingActionOrdersCount = async () => {
    setIsLoading(true);
    const response = await getPendingActionOrdersCount();
    const { data } = response;
    if (data.result.isSuccess) {
      setPendingOrdersCount(data.data.count);
    } else {
      showErrorNotification(data.result.description);
      if (data.result.code == -2) {
        redirectToLogout();
      }
    }
    setIsLoading(false);
  };

  const accessBagUpdatesPage = () => {
    let history = createHistory();
    history.push("/admin/orders/bagUpdates");
    let pathUrl = window.location.href;
    window.location.href = pathUrl;
  };

  useAsyncEffect(async () => {
    callGetStats();
    callGetPendingActionOrdersCount();
  }, []);

  return (
    <>
      <div className={classes.header}>
        <Container
          maxWidth={false}
          component={Box}
          classes={{ root: classes.containerRoot }}
        >
          <Grid
            container
            component={Box}
            alignItems="center"
            paddingTop="1.5rem"
            paddingBottom="1.5rem"
          >
            <Grid item xs={12} className={classes.gridItem}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                width="100%"
              >
                <Typography
                  variant="h2"
                  component="h6"
                  className={clsx(
                    classes.displayInlineBlock,
                    classes.mb0,
                    classes.textBlack
                  )}
                >
                  Dashboard
                </Typography>
                {showViewToggle && (
                  <Box
                    display="inline-flex"
                    borderRadius="10px"
                    bgcolor="rgba(0,0,0,0.06)"
                    p="4px"
                    marginLeft="auto"
                  >
                    {[
                      { key: "app", label: "App" },
                      { key: "pos", label: "Walk-in / POS" },
                    ].map((v) => (
                      <Button
                        key={v.key}
                        size="small"
                        disableElevation
                        onClick={() => onViewChange && onViewChange(v.key)}
                        style={{
                          borderRadius: "8px",
                          textTransform: "none",
                          fontWeight: 600,
                          minWidth: 84,
                          padding: "5px 16px",
                          boxShadow: "none",
                          color: view === v.key ? "#fff" : "rgba(0,0,0,0.6)",
                          backgroundColor:
                            view === v.key
                              ? theme.palette.primary.main
                              : "transparent",
                        }}
                      >
                        {v.label}
                      </Button>
                    ))}
                  </Box>
                )}
              </Box>
            </Grid>
            {/* <Grid item xs={3} lg={4} className={classes.gridItem}>

            </Grid>

            <UserDropdown /> */}
          </Grid>

          {!showPos && pendingOrdersCount > 0 && <Grid container spacing={2} style={{ marginBottom: 16 }}>
            <Grid item xs={12}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                borderRadius="12px"
                px={3}
                py={2}
                boxShadow={3}
                style={{
                  background: "linear-gradient(90deg, #ff6a00 0%, #ee0979 100%)",
                  color: "#fff"
                }}
              >
                <Box display="flex" alignItems="center">
                  <Box
                    bgcolor="rgba(255, 255, 255, 0.15)"
                    p={1.2}
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mr={2}
                  >
                    <HourglassEmptyRounded style={{ color: "#fff" }} />
                  </Box>
                  <Box>
                    <Typography variant="h6" style={{ fontWeight: 600, color: "#fff" }}>
                      {pendingOrdersCount} Pending Orders
                    </Typography>
                    <Typography variant="body2" style={{ opacity: 0.9 }}>
                      Action Required
                    </Typography>
                  </Box>
                </Box>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={accessBagUpdatesPage}
                  style={{
                    color: "#fff",
                    borderColor: "#fff",
                    borderRadius: "20px",
                    textTransform: "none",
                    fontWeight: 500,
                    padding: "4px 16px",
                    backgroundColor: "transparent"
                  }}
                >
                  View
                </Button> 
              </Box>
            </Grid>
          </Grid> }
          {!showPos && (
          <>
          <Grid container>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Users"
                title={numberOfUsers.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 }) + ""}
                icon={Group}
                color="bgError"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.success.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Average Rating"
                title={avgRating != null ? avgRating.toFixed(3) + "" : 0}
                icon={Star}
                color="bgWarning"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.error.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Orders"
                title={numberOfOrders.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 }) + ""}
                icon={Receipt}
                color="bgSuccess"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.warning.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Sales"
                title={sales.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency}
                icon={AttachMoney}
                color="bgPrimary"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.success.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
          </Grid>
          <br></br>
          <Grid container>
            {/* <Grid item xl={4} lg={6} xs={12}>
              <CardStats
                subtitle="Active Subs."
                title={activeSubscriptions == null ? 0 :activeSubscriptions.toLocaleString(undefined, {maximumFractionDigits:0,minimumFractionDigits: 0})}
                icon={Check}
                color="bgSuccess"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.success.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={4} lg={6} xs={12}>
              <CardStats
                subtitle="Frozen Subs."
                title={frozenSubscriptions == null ? 0 : frozenSubscriptions.toLocaleString(undefined, {maximumFractionDigits:0,minimumFractionDigits: 0})}
                icon={AcUnit}
                color="bgInfo"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.error.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid> */}
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Active Pro Subs."
                title={activeProSubscriptions == null ? 0 : activeProSubscriptions.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 })}
                icon={Check}
                color="bgInfo"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.error.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Pro Subs. Sales"
                title={proSubscriptionSales != null ? proSubscriptionSales.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency : 0 + " " + currency}
                icon={FeaturedPlayListOutlined}
                color="bgSuccess"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.success.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Pro Ord. Sales"
                title={sumForProActiveOrdersWithoutVat != null ? sumForProActiveOrdersWithoutVat.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency : 0 + " " + currency}
                icon={Receipt}
                color="bgWarning"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.warning.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Total Sales"
                title={totalSales.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency}
                icon={AttachMoney}
                color="bgError"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.success.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
          </Grid>
          <br></br>
          <Grid container>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Total Wallet Balance"
                title={walletTotal != null ? walletTotal.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency : 0 + " " + currency}
                icon={AccountBalanceWallet}
                color="bgWarning"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.warning.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Total Cash Balance"
                title={cashTotal != null ? cashTotal.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency : 0 + " " + currency}
                icon={AccountBalanceWallet}
                color="bgError"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.warning.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>

              <CardStats
                subtitle="Total Non Cash Balance"
                title={nonCashTotal != null ? nonCashTotal.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency : 0 + " " + currency}
                icon={AccountBalanceWallet}
                color="bgSuccess"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.warning.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
            <Grid item xl={3} lg={6} xs={12}>
              <CardStats
                subtitle="Net"
                title={net != null ? net.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency : 0 + " " + currency}
                icon={Receipt}
                color="bgInfo"
                footer={
                  <>
                    <Box
                      component="span"
                      fontSize=".875rem"
                      color={theme.palette.warning.main}
                      marginRight=".5rem"
                      display="flex"
                      alignItems="center"
                    >
                    </Box>
                  </>
                }
              />
            </Grid>
          </Grid>
          </>
          )}
          {showPos && (
            <>
              {/* 6 POS tiles as 3 x 2 (bigger cards) so they fill the row cleanly. */}
              <Grid container>
                <Grid item xl={4} lg={4} xs={12}>
                  <CardStats subtitle="Customers" icon={Group} color="bgError"
                    title={(posStats.numberOfCustomers || 0).toLocaleString(undefined, { maximumFractionDigits: 0 }) + ""} />
                </Grid>
                <Grid item xl={4} lg={4} xs={12}>
                  <CardStats subtitle="POS Orders" icon={Receipt} color="bgSuccess"
                    title={(posStats.numberOfOrders || 0).toLocaleString(undefined, { maximumFractionDigits: 0 }) + ""} />
                </Grid>
                <Grid item xl={4} lg={4} xs={12}>
                  <CardStats subtitle="Total Sales" icon={AttachMoney} color="bgPrimary"
                    title={(posStats.totalSales || 0).toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency} />
                </Grid>
              </Grid>
              <br></br>
              <Grid container>
                <Grid item xl={4} lg={4} xs={12}>
                  <CardStats subtitle="Net (excl. VAT)" icon={Receipt} color="bgInfo"
                    title={(posStats.net || 0).toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency} />
                </Grid>
                <Grid item xl={4} lg={4} xs={12}>
                  <CardStats subtitle="Collected" icon={AttachMoney} color="bgSuccess"
                    title={(posStats.collected || 0).toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency} />
                </Grid>
                <Grid item xl={4} lg={4} xs={12}>
                  <CardStats subtitle="Outstanding (pay on collection)" icon={HourglassEmptyRounded} color="bgWarning"
                    title={(posStats.outstanding || 0).toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 3 }) + " " + currency} />
                </Grid>
              </Grid>
            </>
          )}
          <Snackbar
            place="tr"
            color="rose"
            // icon={AddAlert}
            message={notifMessage}
            open={showError}
            closeNotification={() => setShowError(false)}
            close
          />
        </Container>
      </div>
    </>
  );
};

StatsHeader.propTypes = {
  section: PropTypes.string,
  subsection: PropTypes.string,
  showViewToggle: PropTypes.bool,
  view: PropTypes.string,
  onViewChange: PropTypes.func,
  posStats: PropTypes.object,
};

export default StatsHeader;
